import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function joinWaitlist(payload) {
    const res = await api.post("/waitlist", payload);
    return res.data;
}

export async function getWaitlistCount() {
    const res = await api.get("/waitlist/count");
    return res.data;
}
